export default __webpack_public_path__ + "static/media/ticket.a5a50b91.svg";